














































import { Component, Watch, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class FanMech extends Vue {
  private screenSize: number = screen.width;
  @Watch('screenSize')
    private onchange(val: number, oldVal: number) {
      this.screenSize = val;
    }

    private mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.screenSize = window.innerWidth;
        });
      });
    }
  /* TODO: Move data to service */
  private data() {
    return {
      assets: {
        fan: {
          casing: {
            url: require('../assets/about-mech/fan-casing_106x106.png'),
            alt: 'fan casing',
          },
          blades: {
            url: require('../assets/about-mech/fan-blades_106x106.png'),
            alt: 'fan blades',
          },
          hub: {
            url: require('../assets/about-mech/fan-hub_106x106.png'),
            alt: 'fan hub',
          },
        },
        gearA: {
          url: require('../assets/about-mech/gear-A_130x130.png'),
          alt: 'Gear A',
          highlight: require('../assets/about-mech/gear-A-high_130x130.png'),
          highAlt: 'Gear A High',
        },
        gearB: {
          url: require('../assets/about-mech/gear-B_82x82.png'),
          alt: 'Gear B',
          highlight: require('../assets/about-mech/gear-B-high_82x82.png'),
          highAlt: 'Gear B High',
        },
        gearC: {
          url: require('../assets/about-mech/gear-C_36x36.png'),
          alt: 'Gear C',
          highlight: require('../assets/about-mech/gear-C-high_36x36.png'),
          highAlt: 'Gear C High',
        },
        meter: {
          url: require('../assets/about-mech/meter_74x194.png'),
          alt: 'Meter',
        },
        meterGlow: {
          glow: require('../assets/home-mech/gauge-D-glow_50x44.png'),
          glowAlt: 'Meter Glow',
        },
      },
    };
  }
}
